<template>
  <div class="documents-page page">
    <div class="documents-page__container">
      <h1 class="title">Документы</h1>
      <div class="documents-page__content">
        <p class="documents-page__paragraph">
          -
          <a
            href="/static/documents/4_Пользовательское_соглашение.pdf"
            target="_blank"
          >
            Пользовательское соглашение</a
          >
        </p>
        <p class="documents-page__paragraph">
          -
          <a href="/static/documents/3_Политика_Cookie.pdf" target="_blank">
            Политика Cookie</a
          >
        </p>

        <p class="documents-page__paragraph">
          -
          <a
            href="/static/documents/2_Согласие_на_обработку_ПДн.pdf"
            target="_blank"
          >
            Согласие на обработку ПДн</a
          >
        </p>
        <p class="documents-page__paragraph">
          -
          <a
            href="/static/documents/1_Политика_конфиденциальности.pdf"
            target="_blank"
          >
            Политика конфиденциальности</a
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import DEFAULT_PAGE from "@/graphql/pages/DefaultPage.graphql";
import BreadcrumbsComponent from "components/BreadcrumbsComponent.vue";

export default {
  name: "DocumentsPage",
  async asyncData({ apollo, store }) {
    await apollo.defaultClient
      .query({
        query: DEFAULT_PAGE,
      })
      .then(({ data }) => {
        store.state.all_brands = data.brands || [];
        store.state.popular_brands = data.brands_paginate.data || [];
        store.state.categories = data.header_categories.data || [];
        store.state.pages = data.pages;
        store.state.marketplace = data.marketplace;
      });
  },
  components: {
    BreadcrumbsComponent,
  },
  metaInfo: {
    title: "Документы",
  },
};
</script>

<style lang="stylus">
.documents-page {
  width 100%
  display grid
  grid-gap 30px
  padding: 32px 15px 48px;
  +below(420px) {
    grid-gap 16px
  }
  &__container {
    padding-left: var(--sides_padding);
    padding-right: var(--sides_padding);
  }
  &__content {
    display grid
    grid-gap 16px
    width 100%
    max-width var(--main_width)
    & > * {
      margin 10px 0

      &:first-child {
        margin-top: 0;
      }
    }
  }
  &__paragraph {
    a {
      border-bottom: 1px solid var(--dark)
    }
  }

}
</style>
